import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { PropertyCharacteristicsDto, PropertyPhotoDto } from '@workspace/data-types';
import { EtxeEnumDisplayPipe } from '../../../pipes/etxe-enum-display.pipe';

@Component({
  selector: 'etxe-property-photos-carousel',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatDialogModule, EtxeEnumDisplayPipe],
  templateUrl: './photos-carousel.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '(window:keydown)': 'handleKeyboardEvent($event)',
    class: 'block',
  },
})
export class EtxePropertyPhotoCarouselComponent {
  currentIndex = signal(0);
  public dialogRef = inject(MatDialogRef<EtxePropertyPhotoCarouselComponent>);
  public data = inject<{
    photos: PropertyPhotoDto[];
    initialIndex: number;
    characteristics?: PropertyCharacteristicsDto;
  }>(MAT_DIALOG_DATA);

  constructor() {
    this.currentIndex.set(this.data.initialIndex);
  }

  next() {
    this.currentIndex.update((i) => (i + 1) % this.data.photos.length);
  }

  prev() {
    this.currentIndex.update((i) => (i - 1 + this.data.photos.length) % this.data.photos.length);
  }

  goTo(index: number) {
    this.currentIndex.set(index);
  }

  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'ArrowRight') this.next();
    if (event.key === 'ArrowLeft') this.prev();
    if (event.key === 'Escape') this.dialogRef.close();
  }
}
